import React, {FC} from "react";
import {useField} from "formik";
import {FormControl, FormControlProps, InputLabel, MenuItem, Select, Typography} from "@material-ui/core";

interface FormikTextFieldProps {
    name: string;
    label?: string;
    options: {value: string; label: string}[]
}

export const FormikSelect: FC<FormikTextFieldProps & Omit<FormControlProps, 'name'>> = (props) => {
    const {name, ...restProps} = props;

    const [, meta, helpers] = useField<string>(name);

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        helpers.setValue(event.target.value as string);
    };

    return (
        <FormControl {...restProps}>
            <InputLabel error={Boolean(meta.error)} id="demo-simple-select-label">{props.label}</InputLabel>
            <Select
                error={Boolean(meta.error)}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={meta.value ?? ""}
                onChange={handleChange}
            >
                {props.options.map(o => ( <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>))}
            </Select>
            <Typography color={"error"}>{meta.error}</Typography>
        </FormControl>
    )
}
